<template>
  <div>
    <div>
      <section class="Haut">
        <header class="Fiche__header text-moyen">
          <div class="tl block text-bold">{{ date }} - références</div>
          <div class="tc block text-bold">&nbsp;</div>
          <div class="tr block text-bold">scalene architectes</div>
        </header>
      </section>
      <section
        class="Fiche__title ProjectTextIndex__title text-ttgros"
        v-if="title"
      >
        <span
          style="margin-top: -9px;
    margin-bottom: -7px;
    display: block;"
          >{{ title }}</span
        >
      </section>
      <div class="Fiche__header__notitle__spacer" v-else></div>
    </div>
    <table class="ProjectTextIndex">
      <thead>
        <tr>
          <th style="width: 39mm"><p>Projet &ndash; Programme</p></th>
          <th style="width: 27mm"><p>Lieu &ndash; date</p></th>
          <th style="width: 34.5mm"><p>Maîtrise d'ouvrage</p></th>
          <th style="width: 31.5mm"><p>Maîtrise d'œuvre</p></th>
          <th style="width: 20.725mm"><p>Procédure</p></th>
          <th style="width: 20.175mm"><p>m² &ndash; budget</p></th>
          <svg width="100%" height="1px">
            <path
              style="fill:none;fill-opacity:1;stroke:#31287c;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1"
              d="M 0,0 H 5000"
            />
          </svg>
        </tr>
      </thead>
      <tbody>
        <slot> </slot>
      </tbody>
    </table>
    <span
      class="pageNumber ProjectTextIndex__pageNumber text-moyen"
      v-if="total > 1"
      >{{ index }}/{{ total }}</span
    >
  </div>
</template>
<script>
export default {
  name: "FichePortraitIndexTextuelCommon",
  props: {
    date: {},
    total: {},
    index: {},
    title: {}
  }
};
</script>
